<template>
    <div ref="menu">
        <template v-if="data.data.db == 'filesystem' || data.data.db == 'public' || data.data.db == 'group'">
            <template v-if="!data.data.is_group">
                <ul @click="close">
                    <li @click="view_doc_file" v-if="!data.data.is_dir && data.data.extname === '.docx' || data.data.extname === '.doc' || data.data.extname === '.xlsx' || data.data.extname === '.xls' || data.data.extname === '.pptx' || data.data.extname === '.ppt'">
                        <i class="fa fa-eye"></i> View File
                    </li>
                    <li @click="view_txt(data.index, data.data.id)" v-if="!data.data.is_dir && data.data.extname === '.txt'">
                        <i class="fa fa-eye"></i> View File
                    </li>
                    <li @click="play_video(data.data.id)" class="player" v-if="!data.data.is_dir && data.data.type === 'video'">
                        <i class="play">
                            <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
                            </svg>
                            <span>Play Video</span>
                        </i>
                    </li>
                    <li @click="play_audio(data.data.id)" class="player" v-if="!data.data.is_dir && data.data.type === 'audio'">
                        <i class="play">
                            <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
                            </svg>
                            <span>Play Audio</span>
                        </i>
                    </li>
                    <li @click="view_file(data.data.id)" class="player" v-if="!data.data.is_dir && data.data.type === 'image'">
                        <i class="play">
                            <svg style="width:16px;height:16px;left:5px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z" />
                            </svg>
                            <span>View File</span>
                        </i>
                    </li>
                    <li class="player" v-if="!data.data.is_dir && data.data.extname === '.pdf'">
                        <i class="play" @click="viewpdf(data.data.id)">
                            <svg style="width:16px;height:16px;left:5px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z" />
                            </svg>
                            <span>View File</span>
                        </i>
                    </li>
                    <li class="player" v-if="!data.data.is_dir && data.data.extname !== ''">
                        <i class="play" @click="download(data.data.id)">
                            <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                            </svg>
                            <span>Download</span>
                        </i>
                    </li>
                    <li class="line-div"></li>
                    <li @click="file_info()">
                        <i class="rename">
                            <svg style="width:15px;height:15px" viewBox="0 0 24 24">
                                <path fill="#000000" d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
                            </svg>
                        </i>File Info
                    </li>
                </ul>
            </template>
            <template v-if="data.data.is_group && data.data.is_group_parent != true">
                <ul @click="close">
                    <li v-if="!data.data.is_dir && data.data.extname === '.docx' || data.data.extname === '.doc' || data.data.extname === '.xlsx' || data.data.extname === '.xls' || data.data.extname === '.pptx' || data.data.extname === '.ppt'">
                        <i class="fa fa-eye"></i> View File
                    </li>
                    <li v-if="!data.data.is_dir && data.data.extname === '.docx' || data.data.extname === '.doc' || data.data.extname === '.xlsx' || data.data.extname === '.xls' || data.data.extname === '.pptx' || data.data.extname === '.ppt'">
                        <i class="pen">
                            <svg style="width:17px;height:17px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M15.54,3.5L20.5,8.47L19.07,9.88L14.12,4.93L15.54,3.5M3.5,19.78L10,13.31C9.9,13 9.97,12.61 10.23,12.35C10.62,11.96 11.26,11.96 11.65,12.35C12.04,12.75 12.04,13.38 11.65,13.77C11.39,14.03 11,14.1 10.69,14L4.22,20.5L14.83,16.95L18.36,10.59L13.42,5.64L7.05,9.17L3.5,19.78Z" />
                            </svg>
                        </i> Edit File
                    </li>
                    <li @click="view_txt(data.index, data.data.id)" v-if="!data.data.is_dir && data.data.extname === '.txt'">
                        <i class="fa fa-eye"></i> View File
                    </li>
                    <li @click="play_video(data.data.id)" class="player" v-if="!data.data.is_dir && data.data.type === 'video'">
                        <i class="play">
                            <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
                            </svg>
                            <span>Play Video</span>
                        </i>
                    </li>
                    <li @click="play_audio(data.data.id)" class="player" v-if="!data.data.is_dir && data.data.type === 'audio'">
                        <i class="play">
                            <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
                            </svg>
                            <span>Play Audio</span>
                        </i>
                    </li>
                    <li @click="view_file(data.data.id)" class="player" v-if="!data.data.is_dir && data.data.type === 'image'">
                        <i class="play">
                            <svg style="width:16px;height:16px;left:5px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z" />
                            </svg>
                            <span>View File</span>
                        </i>
                    </li>
                    <li class="player" v-if="!data.data.is_dir && data.data.extname === '.pdf'">
                        <i class="play" @click="viewpdf(data.data.id)">
                            <svg style="width:16px;height:16px;left:5px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z" />
                            </svg>
                            <span>View File</span>
                        </i>
                    </li>
                    <li class="player" v-if="!data.data.is_dir && data.data.extname !== '' && data.data.download_right">
                        <i class="play" @click="download(data.data.id)">
                            <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                            </svg>
                            <span>Download</span>
                        </i>
                    </li>
                    <li class="line-div"></li>
                    <li @click="file_info()">
                        <i class="rename">
                            <svg style="width:15px;height:15px" viewBox="0 0 24 24">
                                <path fill="#000000" d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
                            </svg>
                        </i>File Info
                    </li>
                </ul>
            </template>
        </template>
        <template v-if="data.data.db == 'sharedwithme'">
            <ul @click="close" ref="menu">
                <li v-if="!data.data.is_dir && data.data.extname === '.docx' || data.data.extname === '.doc' || data.data.extname === '.xlsx' || data.data.extname === '.xls' || data.data.extname === '.pptx' || data.data.extname === '.ppt'">
                    <i class="fa fa-eye"></i> View File
                </li>
                <li @click="view_txt(data.index, data.data.file_id)" v-if="!data.data.is_dir && data.data.extname === '.txt'">
                    <i class="fa fa-eye"></i> View File
                </li>
                <li @click="play_video(data.data.file_id)" class="player" v-if="!data.data.is_dir && data.data.type === 'video'">
                    <i class="play">
                        <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
                        </svg>
                        <span>Play Video</span>
                    </i>
                </li>
                <li @click="play_audio(data.data.file_id)" class="player" v-if="!data.data.is_dir && data.data.type === 'audio'">
                    <i class="play">
                        <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
                        </svg>
                        <span>Play Audio</span>
                    </i>
                </li>
                <li @click="view_file(data.data.file_id)" class="player" v-if="!data.data.is_dir && data.data.type === 'image'">
                    <i class="play">
                        <svg style="width:16px;height:16px;left:5px" viewBox="0 0 24 24">
                            <path fill="#2c3e50" d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z" />
                        </svg>
                        <span>View File</span>
                    </i>
                </li>
                <li class="player" v-if="!data.data.is_dir && data.data.extname === '.pdf'">
                    <i class="play" @click="viewpdf(data.data.file_id)">
                        <svg style="width:16px;height:16px;left:5px" viewBox="0 0 24 24">
                            <path fill="#2c3e50" d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z" />
                        </svg>
                        <span>View File</span>
                    </i>
                </li>
                <template v-if="data.data.download">
                    <li class="player" v-if="!data.data.is_dir && data.data.extname !== ''">
                        <i class="play" @click="downloadshared(data.data.file_id)">
                            <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                                <path fill="#2c3e50" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                            </svg>
                            <span>Download</span>
                        </i>
                    </li>
                </template>
                <li @click="file_info()">
                    <i class="rename">
                        <svg style="width:15px;height:15px" viewBox="0 0 24 24">
                            <path fill="#000000" d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
                        </svg>
                    </i>File Info
                </li>
            </ul>
        </template>
    </div>
</template>
<script>
import config from '@/services/config'
import cookies from '@/services/cookies'
import { mapMutations } from 'vuex'

export default {
  props: {
    data: {
      data: Object,
      index: Number
    }
  },
  data () {
    return {

    }
  },
  methods: {
    view_doc_file () {
      // this.$router.push('view-doc/'+this.data.data.id)
      let a = document.createElement('a')
      // process.env.VUE_APP_NODE_ENV == 'development' ? cookies.set('token', cookies.getCookie('token'), { path: '/' }) : cookies.set('token', cookies.getCookie('token'), { domain: '.fexspace.com', secure: true, expires: 6 * 60 * 60 * 1000 })
      a.setAttribute('href', process.env.VUE_APP_HTTP + '://' + location.host + '/view-user-doc/' + this.data.data.id)
      a.setAttribute('target', '_blank')
      a.hidden = true
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    str_text (str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5)
        let sSeg = str.substr(str.length - 12, 4)

        return fSeg + '....' + sSeg
      }

      return str
    },
    // eslint-disable-next-line camelcase
    adduser (id, folder_name) {
      this.$parent.addusertofolder(id, folder_name)
    },
    // eslint-disable-next-line camelcase
    edituser (id, folder_name) {
      this.$parent.editusertofolder(id, folder_name)
    },
    close (e) {
      if (e.target.nodeName === 'LI' || e.target.nodeName === 'I') {
        this.data.data.show = false
      }
    },
    viewpdf (id) {
      this.$parent.viewpdf(id)
    },
    view_txt (index, id) {
      this.$parent.view_txt(index, id)
    },
    view_file (id) {
      this.$parent.view_file(this.data.index, id)
    },
    play_video (id) {
      this.$parent.play_video(this.data.index, id)
    },
    play_audio (id) {
      this.$parent.play_audio(this.data.index, id)
    },
    copyto () {
      this.$parent.copyto(this.data.index)
    },
    moveto () {
      this.$parent.moveto(this.data.index)
    },
    download (id) {
      let token = cookies.getCookie('token')

      let a = document.createElement('a')
      a.setAttribute('download', true)
      a.setAttribute('href', process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/download?id=' + id + '&token=' + token)
      a.hidden = true
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    downloadshared (id) {
      let token = cookies.getCookie('token')

      let a = document.createElement('a')
      a.setAttribute('download', true)
      a.setAttribute('href', process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/download?id=' + id + '&token=' + token)
      a.hidden = true
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    file_info () {
      if (this.data.data.db === 'sharedwithme') {
        this.$parent.show_file_info(this.data.data)
      }

      if (this.data.data.db === 'sharedfiles') {
        this.$parent.show_file_info(this.data.data)
      }

      if (this.data.data.db === 'group') {
        this.$parent.show_file_info(this.data.data)
      }

      if (this.data.data.db !== 'sharedwithme' && this.data.data.db !== 'sharedfiles' && this.data.data.db !== 'group') {
        this.$parent.show_file_info(this.data.data)
      }
    }
  },
  mounted () {
    //console.log(this.data.data)
  }
}
</script>
